import * as z from "zod";
import { assertCanChangeLiveness } from "./livenessGate";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

export const unpauseWorkflow = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: z.object({
    analytics: monitoringAnalytics.optional(),
    workflowId: z.string(),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow } }) => {
    await assertCanChangeLiveness(tx, ctx, workflow);
    await tx.mutate.workflows.update({
      id: workflow.id,
      pausedAt: null,
    });
  },
});
